import validate from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/pages/runtime/validate.js";
import luigisbox_45global from "/builds/shop22/kik-storefront-monorepo/storefront/middleware/luigisbox.global.ts";
import page_45tracking_45global from "/builds/shop22/kik-storefront-monorepo/storefront/middleware/page-tracking.global.ts";
import redirect_45trailing_45slash_45global from "/builds/shop22/kik-storefront-monorepo/storefront/middleware/redirect-trailing-slash.global.ts";
import manifest_45route_45rule from "/builds/shop22/kik-storefront-monorepo/storefront/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  luigisbox_45global,
  page_45tracking_45global,
  redirect_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "cache-control": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/cache-control.ts"),
  "cart-not-empty": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/cart-not-empty.ts"),
  "href-lang": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/hrefLang.ts"),
  "is-authenticated": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/is-authenticated.ts"),
  "mykik-app-signin": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/mykik-app-signin.ts"),
  "switch-view-redirect": () => import("/builds/shop22/kik-storefront-monorepo/storefront/middleware/switch-view-redirect.ts")
}